import axios from "axios";

export default axios.create({
  baseURL: "https://datamart.bookingjini.com/rateshopper",
});
